<template>
    <div
        :class="['item', cls, { 'selected': selected, 'disabled': disabled }]"
        @click="handleClick">
        <i v-if="icon" class="icon" :class="[icon, color]"></i>
        <img v-else-if="image" class="contain" :src="image" :width="imageWidth" :height="imageHeight"/>
        <span v-if="text" :class="['text', 'fw-bold', color]" v-html="text"></span>
    </div>
</template>

<script>
export default {
    name: "Radio",

    props: {
        selected: {
            type: Boolean,
            required: false,
        },
        cls: {
            type: String,
            required: false,
        },
        text: {
            type: String,
            required: false,
        },
        color: {
            type: String,
            required: false,
        },
        icon: {
            type: String,
            required: false,
        },
        image: {
            type: String,
            required: false,
        },
        imageWidth: {
            type: String,
            required: false,
            default: '30px'
        },
        imageHeight: {
            type: String,
            required: false,
            default: '30px'
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
    },

    watch: {
        selected(isTrue) {
            if (isTrue) {
                this.$el.scrollIntoView({behavior: 'smooth', block: 'nearest'});
            }
        }
    },

    methods: {
        handleClick() {
            if (!this.disabled) {
                this.$emit('click', this.value);
            }
        }
    }
}
</script>
